const AdminLoginModel = (object) => ({
    Email: "",
    Password: "",
    errormsg: "",
    UserType: 'admin'
});

export default AdminLoginModel;